import { AiFillGithub } from 'react-icons/ai';
import { ImLinkedin } from 'react-icons/im';
import { IconContext } from "react-icons";
import style from  './Rodape.module.scss';

const Rodape = () => {
  return (
    <section className={style.rodape}>    
     <div className={style.social}> 

      <a href="https://github.com/tamaracosta" target="_blank" rel="noopener noreferrer">
        <IconContext.Provider
            value={{ color: '#f4c434' }}
        >
          <AiFillGithub size={30} />
        </IconContext.Provider>
      </a>

      <a href="https://www.linkedin.com/in/tamaradscosta/" target="_blank" rel="noopener noreferrer">
      <IconContext.Provider
            value={{ color: '#f4c434' }}
        >
          <ImLinkedin size={28}/>
        </IconContext.Provider>
      </a>
      
              
           
      <h4>Desenvolvido por Tamara Costa</h4>      
     </div>           
     
  </section>
)
}

export default Rodape;